import { MilestoneStatusCode as SourceMilestoneStatus } from '@bechtel/types';

export interface CommodityStatusLegendProps {
  isWeldCommodity?: boolean;
}

export const MilestoneStatus = {
  PLANNED: SourceMilestoneStatus.PLANNED,
  CLAIMED: SourceMilestoneStatus.CLAIMED,
  APPROVED: SourceMilestoneStatus.APPROVED,
  REJECTED: SourceMilestoneStatus.REJECTED,
  BLOCKED: SourceMilestoneStatus.BLOCKED,
};
